import styled from '@emotion/styled';
import React from 'react';
import { breakpointQueries } from '../../utils/styleguide';

function createSrcSet(sources: SourceSetPropType) {
  const sourceArray = Object.entries(sources);
  const sourceSet = sourceArray.reduce((acc, [size, source]) => `${acc}${source} ${size}x,`, '');
  return sourceSet;
}

const Picture = styled.picture`
  overflow: hidden;
  img {
    width: 100%;
    height: auto;
  }
`;

export type Sources = {
  desktop: SourceSetPropType;
  tablet: SourceSetPropType;
  mobile: SourceSetPropType;
};

type Props = {
  sources?: Sources;
  alt?: string;
  className?: string;
  loading?: 'lazy' | 'eager';
};

function ResponsiveImage({ sources, alt, className, ...rest }: Props) {
  if (!sources) return null;
  return (
    <Picture className={className}>
      <source media={breakpointQueries.desktop} srcSet={createSrcSet(sources.desktop)} />
      <source media={breakpointQueries.tablet} srcSet={createSrcSet(sources.tablet)} />
      <source srcSet={createSrcSet(sources.mobile)} />
      <img srcSet={createSrcSet(sources.desktop)} alt={alt} {...rest} />
    </Picture>
  );
}

type SourceSetPropType = {
  1?: string;
  2?: string;
  3?: string;
  4?: string;
};

export default ResponsiveImage;
